import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSubscriptionApi } from "src/_common/hooks/actions/subscription/appSubscriptionApiHook";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useTranslation } from "src/_common/hooks/useTranslation";
import { URLS } from "src/_config";

const PaymentCancel: React.FC = () => {
    const history = useHistory();
    const location = useLocation();
    const subscriptionApi = useSubscriptionApi();
    const userApi = useUserApi();
    const toast = useToaster();
    const { t } = useTranslation("payment");
    const [isProcessing, setIsProcessing] = useState(true);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);


    useEffect(() => {
        // Parse query parameters from URL
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get('token');
        const subscription_id = searchParams.get('subscription_id');
        const ba_token = searchParams.get('ba_token');

        console.log('Payment Cancel - Token:', token, 'Subscription ID:', subscription_id);

        console.log('Payment Cancel - Token:', token);

        if (token && subscription_id && ba_token) {
            // Call payment cancel API
            subscriptionApi.callPaymentCancel(
                {
                    token: token,
                    subscription_id: subscription_id,
                    ba_token: ba_token
                },
                (message: string, response: any) => {
                    console.log('Payment cancel API response:', response);
                    setIsProcessing(false);
                    setShowCancelModal(true);
                    toast.warning(message || "Payment was cancelled");

                    // Redirect to subscriptions page after 2 seconds
                    setTimeout(() => {
                        history.push(URLS.SETTINGS.SUBSCRIPTIONS);
                    }, 2000);
                },
                (error: any) => {
                    console.error('Payment cancel API error:', error);
                    setIsProcessing(false);

                    // Error response structure: {status: 400, message: "...", data: null}
                    const errorMsg = error?.message || error?.data?.message || "Failed to process payment cancellation";
                    setErrorMessage(errorMsg);

                    // Still show the modal even on error to inform the user
                    setShowCancelModal(true);
                    toast.error(errorMsg);

                    // Redirect to subscriptions page after showing error
                    setTimeout(() => {
                        history.push(URLS.SETTINGS.SUBSCRIPTIONS);
                    }, 3000);
                }
            );
        } else {
            console.error('Missing token');
            setIsProcessing(false);
            toast.error("Transaction cancellation.");

            setTimeout(() => {
                history.push(URLS.SETTINGS.SUBSCRIPTIONS);
            }, 2000);
        }
    }, [location.search]);

    return (
        <div className="dashboard-main member-page-wrapper payment-cancel-wrapper">
            <div className="payment-cancel-container">
                <div className="payment-cancel-card">
                    {isProcessing && !showCancelModal ? (
                        <>
                            <div className="payment-processing-spinner"></div>
                            <h1 className="payment-processing-title">{t("paymentCancel.processing.title")}</h1>
                            <p className="payment-processing-message" dangerouslySetInnerHTML={{ __html: t("paymentCancel.processing.message") }}>
                            </p>
                        </>
                    ) : null}
                    
                    {showCancelModal && (
                        <>
                            <div className="payment-cancel-icon">
                                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </div>
                            <h1 className="payment-cancel-title">{t("paymentCancel.error.title")}</h1>
                            <p className="payment-cancel-subtitle">
                                {t("paymentCancel.error.subtitle")}
                            </p>
                            <p className="payment-cancel-description">
                                {errorMessage || <span dangerouslySetInnerHTML={{ __html: t("paymentCancel.error.description") }} />}
                            </p>

                            <div className="payment-cancel-actions">
                                <button
                                    onClick={() => history.push(URLS.SETTINGS.SUBSCRIPTIONS)}
                                    className="btn-preview"
                                >
                                    {t("paymentCancel.error.tryAgain")}
                                </button>
                                <button
                                    onClick={() => history.push(URLS.DASHBOARD.MAIN)}
                                    className="btn-cancel"
                                >
                                    {t("paymentCancel.error.goToDashboard")}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PaymentCancel;
